import React from 'react';
import { Helmet } from 'react-helmet-async';

import { Typography } from 'antd';
import { AuditOutlined } from '@ant-design/icons';

const ClientSVAReviewPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>SVA Review | Mabel</title>
      </Helmet>
      <Typography.Title level={3}>
        <AuditOutlined /> SVA Review
      </Typography.Title>
    </>
  );
};

export default ClientSVAReviewPage;
